<template>
  <b-card class="employee-manage">
    <div style="position: relative">
      <loading-overlay :loading="loading" />

      <div class="d-flex justify-content-between">
        <h3>{{ isVolunteer ? "المتطوعين" : "الموظفين" }}</h3>
        <b-button
          v-can="{ slug: $route.meta.slug, action: 'C' }"
          :key="$route.meta.slug"
          variant="success"
          @click="openEditPage('new')"
        >
          <feather-icon icon="PlusIcon" />
          إضافة {{ isVolunteer ? "متطوع" : "موظف" }}</b-button
        >
      </div>
      <hr />
      <EmployeesFilters @filterChanged="filterTable" />

      <b-row>
        <b-col
          cols="12"
          v-can="{ slug: $route.meta.slug, action: 'S' }"
          :key="`${$route.meta.slug}_table`"
        >
          <data-table ref="employeesTable" :ep="getEp" striped :fields="fields">
            <template #cell(avatar)="data">
              <b-avatar
                :src="
                  data.item.gander == 1
                    ? require('@/assets/global/user_male.png')
                    : require('@/assets/global/female_user.png')
                "
                style="background-color: #fff; border: 1px solid #ccc"
              />
            </template>

            <template #cell(branch)="{ value }">
              {{ value ? value.governorate_name : "المقر الرئيسي" }}
            </template>

            <template #cell(_)="row">
              <div class="d-flex align-items-center justify-content-end">
                <b-button
                  variant="flat-info"
                  @click="row.toggleDetails"
                  title="عرض المزيد من المعلومات"
                  size="sm"
                  class="btn-icon rounded-circle"
                  v-b-tooltip.hover.v-info.top
                >
                  <feather-icon icon="InfoIcon" size="1.8x" color="#4fc98c" />
                </b-button>
                <b-dropdown
                  variant="link"
                  no-caret
                  :left="$store.state.appConfig.isRTL"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                  </template>

                  <b-dropdown-item
                    v-can="{ slug: $route.meta.slug, action: 'U' }"
                    @click="openEditPage(row.item.id)"
                  >
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50">تعديل</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-can="{ slug: $route.meta.slug, action: 'D' }"
                    @click="onDelete(row.item.id)"
                  >
                    <feather-icon icon="Trash2Icon" />
                    <span class="align-middle ml-50">حذف</span>
                  </b-dropdown-item>
                  <!-- <b-dropdown-item
                    @click="
                      activRouls = true;
                      id_employee = row.item.id;
                    "
                  >
                    <feather-icon icon="UserIcon" v-if="!isVolunteer" />
                    <span class="align-middle ml-50">العضوية</span>
                  </b-dropdown-item> -->
                </b-dropdown>
              </div>
            </template>
            <template #row-details="row">
              <b-card>
                <b-row class="mb-2">
                  <b-col md="4" class="mb-1 d-flex">
                    <strong>عنوان السكن :</strong>
                    <div class="text-info mx-1">{{ row.item.address }}</div>
                  </b-col>

                  <b-col md="4" class="mb-1 d-flex">
                    <strong>اسم الأب : </strong>
                    <div class="text-info mx-1">{{ row.item.father_name }}</div>
                  </b-col>
                  <b-col md="4" class="mb-1 d-flex">
                    <strong>اسم الأم : </strong>
                    <div class="text-info mx-1">{{ row.item.mother_name }}</div>
                  </b-col>
                  <b-col md="4" class="mb-1 d-flex">
                    <strong>معلومات التواصل : </strong>
                    <div class="text-info mx-1">
                      {{ row.item.contact_number }}
                    </div>
                  </b-col>
                  <b-col v-if="!isVolunteer" md="4" class="mb-1 d-flex">
                    <strong>تاريخ بداية التوظيف : </strong>
                    <div class="text-info mx-1">
                      {{ row.item.employment_date }}
                    </div>
                  </b-col>
                  <b-col md="4" class="mb-1 d-flex">
                    <strong>حالة العضو : </strong>
                    <div class="text-info mx-1">
                      {{ row.item.member_status === 1 ? "نشط" : "غير نشط" }}
                    </div>
                  </b-col>
                  <b-col md="4" class="mb-1 d-flex">
                    <strong>المؤهلات العلمية : </strong>
                    <div class="text-info mx-1">
                      {{
                        row.item.qualification
                          ? row.item.qualification.title
                          : ""
                      }}
                    </div>
                  </b-col>
                  <b-col v-if="!isVolunteer" md="4" class="mb-1 d-flex">
                    <strong>رقم التوظيف ضمن المنظمة : </strong>
                    <div class="text-info mx-1">{{ row.item.code }}</div>
                  </b-col>
                  <b-col md="4" class="mb-1 d-flex" v-if="!isVolunteer">
                    <strong>رقم التأمينات : </strong>
                    <div class="text-info mx-1">
                      {{ row.item.insurance_number }}
                    </div>
                  </b-col>
                </b-row>

                <b-button
                  size="sm"
                  variant="outline-secondary"
                  @click="row.toggleDetails"
                >
                  عرض اقل
                </b-button>
              </b-card>
            </template>
          </data-table>
        </b-col>

        <!-- <modal-board
          :type="typeModel"
          v-model="activModel"
          :info.sync="setObjact"
        ></modal-board> -->

        <!-- <modal-edit-rouls
          v-model="activRouls"
          :id_employee.sync="id_employee"
        /> -->
      </b-row>
    </div>
  </b-card>
</template>

<script>
import DataTable from "@/components/data-table";
import Pagination from "@/components/pagination";
import ModalBoard from "../../components/ModalBoard.vue";
import ModalEditRouls from "../../components/ModalEditRouls";
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BFormCheckbox,
  BCard,
  BModal,
  BDropdown,
  BDropdownItem,
  VBTooltip,
} from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
import Ripple from "vue-ripple-directive";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import EmployeesFilters from "../../components/EmployeesFilters.vue";

export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BFormCheckbox,
    BCard,
    ModalBoard,
    BModal,
    ModalEditRouls,
    Pagination,
    BDropdown,
    BDropdownItem,
    VBTooltip,
    LoadingOverlay,
    EmployeesFilters,
    DataTable,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      id_employee: null,
      deletId: null,
      typeModel: "",
      activModel: false,
      activDelete: false,
      activRouls: false,
      activObject: {},
      fields: [
        {
          key: "avatar",
          label: "",
        },
        { key: "first_name", label: "الاسم الأول" },
        { key: "last_name", label: "الكنية" },
        { key: "id_number", label: "الرقم الوطني" },
        { key: "branch", label: "الفرع" },
        "_",
      ],
    };
  },
  computed: {
    ...mapGetters("AdministrativeStatus/Employees", [
      "employees",
      "loading",
      "pagination",
    ]),
    setObjact() {
      return this.activObject;
    },
    isVolunteer() {
      return this.$route.name === "volunteers";
    },
    type() {
      return this.isVolunteer ? "volunteers" : "employees";
    },
    getEp() {
      return this.isVolunteer ? "v2/volunteers" : "v2/employees";
    },
  },
  methods: {
    ...mapActions("AdministrativeStatus/Employees", ["deleteEmployee"]),
    openEditPage(id) {
      if (this.isVolunteer)
        this.$router.push({ name: "volunteer-show", params: { id } });
      else this.$router.push({ name: "employee-show", params: { id } });
    },
    filterTable(searchParams) {
      this.$refs.employeesTable.setQueryParams(searchParams);
      this.$refs.employeesTable.refreshTable();
    },

    onDelete(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف المستخدم", {
          title: "تأكيد حذف المستخدم",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.deleteEmployee({
              id,
              type: this.type,
            }).then(() => {
              this.$refs.employeesTable.refreshTable();
            });
          }
        });
    },
  },
};
</script>
<style lang="scss">
.employee-manage {
  .button_edit_rouls {
    font-size: 8px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .dropdown.b-dropdown.show.btn-group {
    ul {
      transform: translate3d(-60px, 41px, 0px) !important;
    }
  }
}
</style>
